import { InputRounded } from "@mui/icons-material";
import {
    Box,
    Breadcrumbs,
    Button,
    Card,
    CardContent,
    Container,
    Divider,
    FormControl,
    FormHelperText,
    Grid,
    Input,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Paper,
    Select,
    Typography,
} from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

function CreateNewGroup() {
    const [searchParams] = useSearchParams();
    const groupType = searchParams.get("groupType");
    const navigate = useNavigate();
    const handleGoBack = () => navigate(-1);
    const handleSaveAndCreateNewGroup = () => navigate(`/admin/groups?groupType=${groupType}`);

    return (
        <>
            {/** Breadcrumbs */}
            <Container sx={{ marginY: 2 }}>
                <Breadcrumbs sx={{ my: 1 }}>
                    <div>Admin</div>
                    <div>Groups</div>
                    <div>New</div>
                </Breadcrumbs>
                <Divider />
            </Container>

            {/** Content */}
            <Container sx={{ marginY: 3 }}>
                <Typography variant="h1" fontSize={34} fontWeight="bold">
                    Create New Group
                </Typography>

                {/** Form */}
                <Grid container spacing={3} sx={{ marginY: 3 }}>
                    <Grid item xs={12}>
                        <InputLabel variant="standard" size="string" required>
                            Group Name
                        </InputLabel>
                        <OutlinedInput
                            type="text"
                            name="group.name"
                            placeholder="group name"
                            required
                            size="small"
                            sx={{ minWidth: 500 }}
                        />
                        <FormHelperText>Group name</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel variant="standard" size="string" required>
                            Group Type
                        </InputLabel>
                        <Select name="group.type" size="small" sx={{ minWidth: 500 }}>
                            <MenuItem value="organization">Organization</MenuItem>
                            <MenuItem value="team">Team</MenuItem>
                        </Select>
                        <FormHelperText>Group type: Organization | Team</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel variant="standard" size="string" required>
                            Group Level
                        </InputLabel>
                        <Select name="group.level" size="small" sx={{ minWidth: 500 }}>
                            <MenuItem value="option">dynamic option from api</MenuItem>
                        </Select>
                        <FormHelperText>--</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel variant="standard" size="string" required>
                            Group Visibility
                        </InputLabel>
                        <Select name="group.visibility" size="small" sx={{ minWidth: 500 }}>
                            <MenuItem value="option">dynamic option from api</MenuItem>
                        </Select>
                        <FormHelperText>--</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel variant="standard" size="string">
                            Group Parent
                        </InputLabel>
                        <Select name="group.parent" size="small" sx={{ minWidth: 500 }}>
                            <MenuItem value="option">dynamic option from api</MenuItem>
                        </Select>
                        <FormHelperText>--</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel variant="standard" size="string">
                            Group Parent
                        </InputLabel>
                        <Select name="group.parent" size="small" sx={{ minWidth: 500 }}>
                            <MenuItem value="option">dynamic option from api</MenuItem>
                        </Select>
                        <FormHelperText>--</FormHelperText>
                    </Grid>
                </Grid>

                <Divider sx={{ marginY: 3 }} />

                <Box sx={{ display: "flex", gap: 1 }}>
                    <Button variant="contained" color="primary" onClick={handleSaveAndCreateNewGroup}>
                        Save
                    </Button>
                    <Button variant="outlined" onClick={handleGoBack}>
                        Cancel
                    </Button>
                </Box>
            </Container>
        </>
    );
}

export default CreateNewGroup;
